import React from 'react'
import { Pane, FileUploader, FileCard } from 'evergreen-ui'
import { DOCUMENT_MIME_TYPES } from '../constants/uploadMimeTypes'

const FileUploaderSingleUploadDemo = ({ onFileChange, acceptedMimeTypes = DOCUMENT_MIME_TYPES }) => {
    const [files, setFiles] = React.useState([])
    const [fileRejections, setFileRejections] = React.useState([])
    const handleChange = React.useCallback((acceptedFiles) => {
        const selectedFile = acceptedFiles[0] || null
        setFiles(selectedFile ? [selectedFile] : [])
        if (onFileChange) {
            onFileChange(selectedFile)
        }
    }, [onFileChange])
    const handleRejected = React.useCallback((fileRejections) => {
        setFileRejections([fileRejections[0]])
        setFiles([])
        if (onFileChange) {
            onFileChange(null)
        }
    }, [onFileChange])
    const handleRemove = React.useCallback(() => {
        setFiles([])
        setFileRejections([])
        if (onFileChange) {
            onFileChange(null)
        }
    }, [onFileChange])
    return (
        <Pane maxWidth="20rem">
        <FileUploader
            label="Carica file"
            description="Puoi caricare 1 file alla volta (<=200MB)."
            acceptedMimeTypes={acceptedMimeTypes}
            maxSizeInBytes={200 * 1024 ** 2}
            maxFiles={1}
            onChange={handleChange}
            onRejected={handleRejected}
            renderFile={(file) => {
            const { name, size, type } = file
            const fileRejection = fileRejections.find((fileRejection) => fileRejection.file === file)
            const { message } = fileRejection || {}
            return (
                <FileCard
                key={name}
                isInvalid={fileRejection != null}
                name={name}
                onRemove={handleRemove}
                sizeInBytes={size}
                type={type}
                validationMessage={message}
                />
            )
            }}
            values={files}
        />
        </Pane>
    )
}

export default FileUploaderSingleUploadDemo;